import React from 'react'

import { Collapse as CollapseMUI } from '@mui/material'

import ArrowDownSVG from 'app/assets/icons/arrow-down.svg'
import ArrowUpSVG from 'app/assets/icons/arrow-up.svg'
import useBoolean from 'app/hooks/useBoolean'

import Box, { BoxProps } from '../Box'
import IconButton from '../IconButton/IconButton.web'
import Stack, { StackProps } from '../Stack'
import Text, { TextProps } from '../Text'

export interface CollapseProps {
  title: string
  closedTitle?: string
  sx?: BoxProps['sx']
  open?: boolean
  titleSx?: TextProps['sx']
  titleContainerSx?: StackProps['sx']
}

const Collapse: RFC<CollapseProps> = ({
  title,
  closedTitle,
  sx,
  open,
  titleSx,
  titleContainerSx,
  children
}) => {
  const [isOpen, setOpen] = useBoolean(open)

  const activeTitle = isOpen ? title : closedTitle
  const collapseTitle = closedTitle ? activeTitle : title

  return (
    <Box
      sx={{
        borderBottom: '1px solid',
        borderColor: 'stroke.main',
        ...sx
      }}
    >
      <Stack
        direction="row"
        sx={{
          alignItems: 'center',
          justifyContent: 'space-between',
          cursor: 'pointer',
          py: 3,
          ...titleContainerSx
        }}
        onClick={() => setOpen.toggle()}
      >
        <Text variant="h5" component="h3" sx={{ fontWeight: 500, ...titleSx }}>
          {collapseTitle}
        </Text>

        <IconButton
          size="small"
          disableRipple
          aria-label={isOpen ? 'Collapse section' : 'Expand section'}
        >
          {isOpen ? <ArrowUpSVG /> : <ArrowDownSVG />}
        </IconButton>
      </Stack>

      <CollapseMUI in={isOpen} timeout="auto" unmountOnExit>
        {children}
      </CollapseMUI>
    </Box>
  )
}

export default Collapse
